// extracted by mini-css-extract-plugin
export default {"sliderControlInner":"slider-control__sliderControlInner___a_pfm"};